export const SET_LOCALE = 'USER.SET_LOCALE'
export const SET_PROGRESS = 'USER.SET_PROGRESS'
export const SET_MEMBERSHIP_CODE = 'USER.SET_MEMBERSHIP_CODE'
export const SET_CONSUMER_NETWORK_UUID = 'USER.SET_CONSUMER_NETWORK_UUID'
export const SET_COOKIE_PREFERENCE = 'USER.SET_COOKIE_PREFERENCE'
export const SET_PARTNER_SLUG = 'USER.SET_PARTNER_SLUG'
export const RESET_USER_CONFIG = 'USER.RESET_USER_CONFIG'
